var map = {
	"./20210914-DJI_0010.jpg": 1492,
	"./20210914-DJI_0020.jpg": 8812,
	"./20211107-DJI_0070.jpg": 328,
	"./20220122-DJI_0082.jpg": 940,
	"./20220828-DJI_0035.jpg": 9984,
	"./20221208-DJI_0039.jpg": 5688,
	"./20221208-DJI_0042.jpg": 5444,
	"./20221208-DJI_0043.jpg": 5716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3664;